import React from "react";

/**
 * Logo Caixa avec UNIQUEMENT l'étoile bleue (pas de "HolaBank")
 * - variant="default" : texte noir (pour fond clair)
 * - variant="white"   : texte blanc (pour fond foncé)
 */
const CaixaLogo = ({ size = 40, variant = "default", className = "", showStarOnly = false }) => {
  const textColor = variant === "white" ? "#FFFFFF" : "#000000";
  
  const starSize = size * 0.8;
  const textSize = size * 0.55;
  
  // Étoile CaixaBank (image fournie par l'utilisateur)
  const StarIcon = () => (
    <img
      src="/caixa-star.png"
      alt=""
      width={starSize}
      height={starSize}
      style={{ width: starSize, height: starSize, objectFit: "contain" }}
      draggable={false}
    />
  );
  
  // Si on veut afficher seulement l'étoile
  if (showStarOnly) {
    return <StarIcon />;
  }
  
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} style={{ height: size }}>
      {/* Étoile CaixaBank */}
      <StarIcon />
      
      {/* Texte "Caixa" directement (sans séparateur) */}
      <span
        style={{
          fontSize: textSize,
          fontWeight: 700,
          fontStyle: 'italic',
          color: textColor,
          fontFamily: 'Arial Black, Arial, Helvetica, sans-serif',
          letterSpacing: '-1px',
        }}
      >
        CaixaBank
      </span>
    </div>
  );
};

export default CaixaLogo;
